<template>
	<div @mouseenter="isHovering = true" @mouseleave="isHovering = false" class="input-and-action-container display-flex flex-column">
		<div class="display-flex flex-row">
			<input
				type="text"
				ref="bName"
				@click="editName"
				@blur="inputBlur"
				v-model="blockName"
				@focus="inputFocus"
				class="b_name_input"
				:disabled="!hasEditPermissions"
				:class="{ focused: bNameFocus, hovered: isHovering && !bNameFocus && hasEditPermissions }"
			/>
			<SIcon v-if="isHovering && !bNameFocus && hasEditPermissions" name="edit-name" class="pencil-icon" />
		</div>
		<div v-if="!hideActionText && actionName !== blockName && hasEditPermissions" class="action-text">
			{{ actionName }}
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { canEditWorkflow } from '@/store/modules/workflows/getters';

export default {
	name: 'StepNameInput',
	props: {
		hideActionText: { type: Boolean, default: false },
	},
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		...mapGetters(['selectedNode/editNode', 'apps/getService', canEditWorkflow.fullPath]),
		...mapGetters(['apps/getService', 'apps/getCredentialsForService', 'actions/getAction']),
		hasEditPermissions() {
			return this[canEditWorkflow.fullPath](this.editNode.workflow);
		},
		appInfo() {
			return this['apps/getService'](this.editNode.service) || { service_slug: 'default' };
		},
		isActionNameGiven() {
			return this.editNode.node_title;
		},
		actionName() {
			const action = this['actions/getAction'](this.editNode.action);
			if (action) {
				return action.title;
			} else {
				return this.appInfo.service_name;
			}
		},
		showEditInputStyle() {
			return this.isHovering && !this.isActionNameGiven;
		},
		blockName: {
			get() {
				if (this.showEditInputStyle && this.hasEditPermissions) {
					if (!this.editNameMode) {
						return 'Name this step';
					}
				}
				if (!this.editNode) {
					return this.appInfo.service_name;
				}
				if (this.editNameMode) {
					return this.localBlockName;
				}
				if (!this.editNode.node_title) {
					return this.actionName;
				}
				return this.editNode.node_title;
			},
			set(value) {
				this.localBlockName = value;
				this.setParamInEditNode({ key: 'node_title', value });
			},
		},
	},
	methods: {
		...mapActions('selectedNode', ['setParamInEditNode']),
		inputBlur() {
			this.bNameFocus = false;
			this.editNameMode = false;
		},
		inputFocus() {
			this.bNameFocus = true;
		},
		editName() {
			this.editNameMode = true;
			this.$refs.bName.focus();
		},
	},
	data: () => ({
		bNameFocus: false,
		isHovering: false,
		localBlockName: '',
		editNameMode: false,
	}),
};
</script>
<style scoped lang="scss">
.input-and-action-container {
	width: 100%;
	font-weight: normal;
	color: var(--primart-font-color);
	.action-text {
		font-size: 10px;
	}
	.pencil-icon {
		top: 2px;
		left: -4px;
		position: absolute;
	}
	.b_name_input {
		width: 100%;
		height: 20px;
		font-size: 14px;
		cursor: pointer;
	}
}
.b_name_input.focused {
	cursor: auto;
}
input:focus {
	outline: none;
}
.b_name_input.focused {
	border-bottom: 1px solid var(--primary-color);
}

.b_name_input.hovered {
	color: #d0cfd2 !important;
	border-bottom: 1px dashed var(--border-color);
}
</style>
